import { generatePath, useSearchParams } from 'react-router-dom';
import { Stack } from '@mui/material';

import { Page } from '@components';
import { useRequiredParams } from '@hooks';
import { routes } from '@routes';

import { ASSESSMENT_REPORT_TIER_FILTER, REPORT_TIER_TO_REMEDIATE_PARAM } from '@StandingAccess/types';
import AssessmentReportHeaderItem from '@StandingAccess/organisms/AssessmentReportHeaderItem';
import AssessmentReportAccessRevoke from '@StandingAccess/organisms/AssessmentReportAccessRevoke';
import { useReportFilters } from '@StandingAccess/hooks/use-report-filters';

export default function StandingAccessReportRevokePage() {
  const { id } = useRequiredParams(['id']);
  const { tier } = useReportFilters();

  const viewReportPath = tier
    ? `${generatePath(routes.ViewStandingAccessReport.path, {
        id,
      })}?${ASSESSMENT_REPORT_TIER_FILTER.param}=${tier}&${REPORT_TIER_TO_REMEDIATE_PARAM}=${tier}`
    : generatePath(routes.ViewStandingAccessReport.path, { id });

  return (
    <Page
      title={routes.StandingAccessReportRevoke.label}
      breadcrumbs={[
        { label: routes.StandingAccessReports.label, href: routes.StandingAccessReports.path },
        {
          label: routes.ViewStandingAccessReport.label,
          href: viewReportPath,
        },
      ]}
    >
      <Stack direction="column" spacing={2}>
        <AssessmentReportHeaderItem reportId={id} />
        <AssessmentReportAccessRevoke reportId={id} backPath={viewReportPath} />
      </Stack>
    </Page>
  );
}
